import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
  Checkbox,
  ListItem,
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getAddNewRuleAndVersion,
  getDeleteHealthContructorandGrouperVersion,
  getGrouperVersions,
  getGrouperVersionsData,
  getUpdateGrouperVersionandhelthfundName,
  resetData,
} from "./GrouperSettingsSlice";

function DataGridLayout({ data, onEdit, onDelete, deleting }) {
  // if (!data || data.length === 0) {
  //   return (
  //     <Box sx={{ py: 8, textAlign: "center" }}>
  //       <Typography variant="body1" color="text.secondary">
  //         No rules configured
  //       </Typography>
  //     </Box>
  //   );
  // }

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        bgcolor: "#fff",
      }}
    >
      <Table sx={{ minWidth: 650 }} size="small">
        {/* Table Header */}
        <TableHead>
          <TableRow sx={{ bgcolor: "#f9fafb" }}>
            <TableCell sx={{ fontWeight: 600 }}>Health Fund Contract</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Grouper Versions</TableCell>
             <TableCell sx={{ fontWeight: 600 }}>Display Version</TableCell>
             <TableCell sx={{ fontWeight: 600, width: "120px" }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {data?.map((row, index) => (
            <TableRow
              key={index}
              hover
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell>{row?.health_fund_contract || "---"}</TableCell>

              <TableCell>
                {row?.grouper_versions
                  ?.replace("[", "")
                  ?.replace("]", "")
                  ?.split(",")
                  ?.map((version, idx) => (
                    <Box
                      key={idx}
                      component="span"
                      sx={{
                        display: "inline-block",
                        bgcolor: "#e0f2fe",
                        color: "#0369a1",
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "6px",
                        mr: 0.5,
                        mb: 0.5,
                        fontSize: "0.8rem",
                        fontWeight: 500,
                      }}
                    >
                      {version?.trim()}
                    </Box>
                  )) || "---"}
              </TableCell>
              <TableCell>
                {row?.display_version || "---"}
              </TableCell>

                <TableCell align="center">
                  <IconButton
                    size="small"
                    disabled={deleting}
                    onClick={() => onEdit(row, index)}
                    sx={{
                      color: "#6b7280",
                      "&:hover": { bgcolor: "#f3f4f6", color: "#1a1a1a" },
                    }}
                  ></IconButton>
                  <IconButton
                    size="small"
                    onClick={() => onEdit(row, index)}
                    sx={{
                      color: "#6b7280",
                      "&:hover": { bgcolor: "#f3f4f6", color: "#1a1a1a" },
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => onDelete(index)}
                    sx={{
                      color: "#6b7280",
                      "&:hover": { bgcolor: "#fee2e2", color: "#dc2626" },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default function GrouperSettings() {
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ contract: "", versions: [],displayVersion: "",});
  const [editIndex, setEditIndex] = useState(null);
  const [oldVersionsData, setOldVersionsData] = useState([]);
  const [oldHealthFundName, SetOldHealthFundName] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [oldDisplayVersion, setOldDisplayVersion] = useState("");


  const dispatch = useDispatch();
  const {
    codeAssistData,
    getGrouperVersionsStatus,
    groperVersionData,
    addRuleVersionStatus,
    deleteHealthContructorStatus,
  } = useSelector((state) => state.grouperSettings);


  const tabEndpoints = ["Code Assist", "Code Accelerate", "HL7 message", "Code Workflow"];

  const handleChange = (_, newValue) => setValue(newValue);

  const handleOpen = () => {
    setFormData({ contract: "", versions: [], displayVersion: "",});
    setEditIndex(null);
    setOpen(true);
  };

  const handleEdit = (row, index) => {
    const parseVersions = (versionData) => {
      if (!versionData) return [];
      if (Array.isArray(versionData))
        return versionData.map((v) => v.toString());
      const match = versionData.match(/\[(.*?)\]/);
      if (match) return match[1].split(",").map((v) => v.trim());
      return [];
    };

    
    setOldVersionsData(JSON.parse(row?.grouper_versions));
    SetOldHealthFundName(row?.health_fund_contract);
    setOldDisplayVersion(row?.display_version);
    setFormData({
      contract: row.health_fund_contract,
      versions: parseVersions(row.grouper_versions),
      displayVersion: parseVersions(row.grouper_versions).includes(row?.display_version?.toString())
        ? row.display_version.toString()
        : "",
    });
    setEditIndex(index);
    setOpen(true);
  };

  const confirmDelete = () => {
    if (!rowToDelete) return;

    dispatch(getDeleteHealthContructorandGrouperVersion(rowToDelete))
      .unwrap()
      .then(() => {
        toast.success("Health Fund Contract Deleted successfully!");
        dispatch(getGrouperVersionsData(rowToDelete.module_name));
      })
      .catch(() => {
        toast.error("Failed to delete. Please try again.");
      })
      .finally(() => {
        setShowDeleteModal(false);
        setRowToDelete(null);
      });
  };

  const handleDelete = (index) => {
    const selectedRow = codeAssistData[index];
    if (!selectedRow) return;

    setRowToDelete({
      healthfund_contract: selectedRow.health_fund_contract,
      module_name: tabEndpoints[value],
    });

    setShowDeleteModal(true);  // open modal
  };


  const handleClose = () => {
    setOpen(false);
    setFormData({ contract: "", versions: [],displayVersion: "", });
    setEditIndex(null);
  };


  const handleVersionChange = (event) => {
    const { value } = event.target;
   const selectedVersions =
    typeof value === "string" ? value.split(",") : value;
    setFormData((prev) => ({
      ...prev,
      // versions: typeof value === "string" ? value.split(",") : value,
      versions: selectedVersions,
      displayVersion: selectedVersions.includes(prev.displayVersion)
      ? prev.displayVersion
      : "",
    }));
  };
  const handleDisplayVersionChange = (event) => {
  setFormData((prev) => ({
    ...prev,
    displayVersion: event.target.value,
  }));
  };

  const handleSave = () => {
    if (!formData.contract.trim() || formData.versions.length === 0 ||  !formData.displayVersion) {
      alert("Please fill in all fields");
      return;
    }

    const endpoint = tabEndpoints[value];

    // Common payload base
    const payload = {
      health_fund_contract: formData.contract.trim(),
      config_type: "module",
      module_name: endpoint,
      assign_grouper_version: formData.versions.map((v) => parseFloat(v)),
       display_version: parseFloat(formData.displayVersion), 

    };

    if (editIndex !== null) {
      const oldVersions =
        codeAssistData[editIndex].grouper_versions
          ?.replace("[", "")
          .replace("]", "")
          .split(",")
          .map((v) => v.trim()) || [];

      const newVersions = formData.versions;

      // Find removed and added versions
      // const removedVersions = oldVersions.filter((v) => !newVersions.includes(v));
      // const addedVersions = newVersions.filter((v) => !oldVersions.includes(v));

      // Determine the final grouper_version to send
      // const finalVersions =
      //   removedVersions.length > 0
      //     ? removedVersions
      //     : addedVersions.length > 0
      //     ? addedVersions
      //     : newVersions;

      // Prepare the single payload
      // const updatePayload = {
      //   health_fund: formData.contract.trim(),
      //   module_name: endpoint,
      //   grouper_version: finalVersions.map((v) => parseFloat(v)),
      //   grouper_version_old:oldVersionsData.map((v)=> parseFloat(v)),
      //   Add:addedVersions.length > 0
      // };
      const updatePayload = {
        health_fund_contract: oldHealthFundName,
        new_health_fund: formData.contract.trim(),
        module_name: endpoint,
        grouper_version_new: newVersions.map((v) => parseFloat(v)),
        grouper_version_old: oldVersionsData.map((v) => parseFloat(v)),
        display_version: parseFloat(formData.displayVersion), 

        // Add:addedVersions.length > 0
      };


      dispatch(getUpdateGrouperVersionandhelthfundName(updatePayload))
        .unwrap()
        .then(() => {
          // toast.success("Health Fund Version Updated successfully!");
          handleClose();
          dispatch(getGrouperVersionsData(endpoint));
        })
        .catch(() => toast.error("Failed to update."));
    } else {
      dispatch(getAddNewRuleAndVersion(payload))
        .unwrap()
        .then(() => {
          // toast.success("New Health Fund Contract Added successfully!");
          handleClose();
          dispatch(getGrouperVersionsData(endpoint));
        })
        .catch(() => toast.error("Failed to create."));
    }
  };

  useEffect(() => {
    const endpoint = tabEndpoints[value];
    // if (endpoint === "HL7 message") return;
    dispatch(resetData());
    dispatch(getGrouperVersionsData(endpoint));
    dispatch(getGrouperVersions());
  }, [value, dispatch]);
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  return (
    <Box sx={{ width: "100%", bgcolor: "#f9fafb", minHeight: "100vh", p: 4 }}>
      <ToastContainer autoClose={5000} />
      {/* Header Section */}
      {showDeleteModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "24px",
              borderRadius: "8px",
              width: "350px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          >
            {/* <h3 style={{ marginTop: 0 }}>Confirm Delete</h3> */}

            <p>
              Are you sure you want to delete "
              <strong>{rowToDelete?.healthfund_contract}</strong>"?
            </p>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  background: "#f5f5f5",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={confirmDelete}
                style={{
                  padding: "6px 12px",
                  borderRadius: "4px",
                  border: "none",
                  background: "#d32f2f",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}


      <Box sx={{ mb: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            // mb: 3,
          }}
        >
          <Box>
            <Typography
              variant="body1"
              sx={{
                color: "#000",
                fontWeight: 700,
                fontSize: "1.5rem",
              }}
            >
              Manage health fund contracts and grouper versions
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpen}
            sx={{
              bgcolor: "#4094c8",
              color: "#fff",
              fontWeight: 600,
              borderRadius: "6px",
              px: 3,
              py: 1.2,
              textTransform: "none",
              fontSize: "0.95rem",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "#4094c8",
                boxShadow: "none",
              },
            }}
          >
            Add New Health Fund Contract
          </Button>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          {tabEndpoints.map((label, index) => (
            <Button
              key={label}
              onClick={() => setValue(index)}
              sx={{
                textTransform: "none",
                fontSize: "0.95rem",
                fontWeight: 500,
                // px: 4,
                // py: 1.5,
                borderRadius: "8px",
                bgcolor: value === index ? "#3b82f6" : "#f3f4f6",
                color: value === index ? "#fff" : "#6b7280",
                border: "none",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: value === index ? "#2563eb" : "#e5e7eb",
                  boxShadow: "none",
                },
              }}
            >
              {label}
            </Button>
          ))}
        </Box>
      </Box>

      {/* Content Section */}
      <Box sx={{ bgcolor: "transparent", borderRadius: 1, minHeight: 400 }}>
        {getGrouperVersionsStatus === "loading" ? (
          <>
            <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
              <CircularProgress />
            </Box>
          </>
        ) : (
          <DataGridLayout
            data={codeAssistData}
            onEdit={handleEdit}
            onDelete={handleDelete}
            deleting={deleteHealthContructorStatus === "loading"}
          />
        )}
      </Box>

      {/* Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "#fff",
            boxShadow:
              "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
            borderRadius: "12px",
            width: 600,
            outline: "none",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 3,
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#1a1a1a",
                fontSize: "1.25rem",
              }}
            >
              {editIndex !== null ? "Edit Rule" : "Add New Rule"}
            </Typography>
            <IconButton
              onClick={handleClose}
              size="small"
              sx={{
                color: "#6b7280",
                "&:hover": {
                  bgcolor: "#f3f4f6",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Modal Body */}
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <TextField
                label="Health Contract Name"
                variant="outlined"
                value={formData.contract}
                onChange={(e) =>
                  setFormData({ ...formData, contract: e.target.value })
                }
                placeholder="e.g., BUPA, HCF, MEDIBANK"
                fullWidth
                required
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />

              <TextField
                label="Grouper Versions"
                variant="outlined"
                select
                SelectProps={{
                  multiple: true,
                  value: formData.versions,
                  onChange: handleVersionChange,
                  renderValue: (selected) => selected.join(", "),
                }}
                placeholder="Select versions"
                fullWidth
                required
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              >
                {groperVersionData.map((version) => {
                  const versionStr = version.toString();
                  return (
                    <MenuItem key={versionStr} value={versionStr}>
                      <Checkbox
                        checked={formData.versions.includes(versionStr)}
                        size="small"
                      />
                      {versionStr}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                label="Display Version"
                variant="outlined"
                select
                value={formData.displayVersion}
                onChange={handleDisplayVersionChange}
                fullWidth
                required
                disabled={formData.versions.length === 0}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              >
                {formData.versions.map((version) => (
                  <MenuItem key={version} value={version}>
                    {version}
                  </MenuItem>
                ))}
              </TextField>

              {/* <TextField
                label="Grouper Versions (comma separated)"
                variant="outlined"
                select
                value={formData.versions.join(",")}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    versions: e.target.value.split(",").map((v) => v.trim()),
                  })
                }
                placeholder="e.g., 3.5, 6.5, 7"
                fullWidth
                required
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              /> */}

              {/* Preview */}
              {/* {formData.versions.length > 0 && (
                <Box
                  sx={{
                    p: 2.5,
                    bgcolor: "#f9fafb",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#6b7280",
                      fontSize: "0.75rem",
                      display: "block",
                      mb: 1,
                      fontWeight: 500,
                    }}
                  >
                    Preview:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "monospace",
                      color: "#1a1a1a",
                      fontSize: "0.875rem",
                    }}
                  >
                    [{formData.versions.join(",")}]
                  </Typography>
                </Box>
              )} */}
            </Box>
          </Box>

          {/* Modal Footer */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              p: 3,
              borderTop: "1px solid #e5e7eb",
              bgcolor: "#f9fafb",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                py: 1,
                borderRadius: "6px",
                borderColor: "#d1d5db",
                color: "#6b7280",
                "&:hover": {
                  borderColor: "#9ca3af",
                  bgcolor: "#f9fafb",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={addRuleVersionStatus === "loading"}
              onClick={handleSave}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                py: 1,
                borderRadius: "6px",
                bgcolor: "#3b82f6",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: "#2563eb",
                  boxShadow: "none",
                },
              }}
            >
              {addRuleVersionStatus === "loading"
                ? "Saving..."
                : editIndex !== null
                  ? "Update"
                  : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
